import { Menu } from 'antd';
import { Link } from "react-router-dom";
import { useIntl } from 'react-intl';

// const { SubMenu } = Menu;

export interface SideMenuViewProps{
    menuItems:any[][];
    role:number;
    collapsed: boolean;
    isDropdownOpen:boolean;
    onMenuItemClickedCb:(item:string) => void;
    onMenuCollapseCb:() => void;
    }

export function SideMenuView(props:SideMenuViewProps){
    const intl = useIntl();
    // Labels of the form "SideMenu:..." are message ids from de.js/en.js.
    // Only those: the older plain labels stay as they are, even where a
    // message of the same name exists ("Dashboard", "Login").
    const label = (text: string) =>
        text.startsWith("SideMenu:") ? intl.formatMessage({ id: text, defaultMessage: text }) : text;

    return (
        <div 
            style={{display:"flex", flexDirection: "column",  padding: "12px" }}
        >
               {/* <Button type="primary" onClick={(e) => {props.onMenuCollapseCb()}} style={{ marginBottom: 16 }}>Toggle sidemenu
               {React.createElement(props.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
        </Button> */}
            <Menu  
            theme="dark" 
            mode="vertical" 
            defaultSelectedKeys={['2']}
            items={eintraege(props, label)}
            />
        </div>
    )

}

/**
 * Baut die Menueintraege.
 *
 * antd 6 nimmt das Menue ueber `items` entgegen; `<Menu.Item>` als Kind ist
 * abgekuendigt. Das ist mehr als eine Umbenennung: Die Eintraege sind jetzt
 * Daten, keine Elemente. Ein Eintrag ohne Ziel (item[0] === "") ist eine
 * Zwischenueberschrift und wird zur Gruppe; Eintraege, die der Rolle nicht
 * offenstehen, fallen weg, statt ein leeres <div> zu liefern.
 */
function eintraege(props: SideMenuViewProps, label: (text: string) => string) {
    return props.menuItems
        .filter((item: any[]) => item[3].includes(props.role))
        .map((item: any[], index: number) => {
            if (item[0] === "") {
                return {
                    key: 'gruppe-' + index,
                    type: 'group' as const,
                    label: label(item[1]),
                };
            }

            return {
                key: item[0] + index,
                icon: item[2],
                label: <Link to={item[0]}>{label(item[1])} </Link>,
                onClick: () => { props.onMenuItemClickedCb(item[0]); },
            };
        });
}
